import {EnvEventPutDataTransferObject} from "../../data-transfer-object/env/EnvEventPutDataTransferObject"
import {EnvEventValueObject} from "../../value-object/env/EnvEventValueObject"
import {StatePair, useStatePair} from "react-type-extension"
import {DateFormat} from "ts-format-extension"
import {unwrapUndefinedDate, unwrapUndefinedString} from "ts-type-extension"

export type EnvEventPutState = {
    title: StatePair<string>
    url: StatePair<string>
    toDataTransferObject(): EnvEventPutDataTransferObject
    fromValueObject(vo: EnvEventValueObject): void
    values(): [string, string]
}

export function useEnvEventPutState(): EnvEventPutState {
    return {
        title: useStatePair<string>(''),
        url: useStatePair<string>(''),
        toDataTransferObject(): EnvEventPutDataTransferObject {
            return {
                title: this.title.value,
                url: this.url.value,
            }
        },
        fromValueObject(vo: EnvEventValueObject) {
            this.title.setter(vo.title)
            this.url.setter(vo.url)
        },
        values(): [string, string] {
            return [
                this.title.value,
                this.url.value,
            ]
        }
    }
}
